import { Button, Modal } from 'antd';
import { FunctionComponent, createContext, ReactNode, useState } from 'react';
import { Iconsvg } from '../icon/icon';
interface DialogAlertContextType {
  alert: boolean;
  setAlert: (is: boolean) => void;
  setStatus: (is: string) => void;
  status: string;
  setText: (is: string) => void;
  text: string;
  success: (text?: { header: string; sub: string }) => void;
  error: (text?: { header: string; sub: string }) => void;
}
const DialogAlerContext = createContext<DialogAlertContextType | null>(null);

interface DialogAlertProviderProps {
  children: ReactNode;
}
// const success = (text?: string) => {
//   Modal.success({
//     centered: true,
//     className: 'modal-alert',
//     content: text ? text : 'some messages...some messages...',
//     closable: true,
//   });
// };

const DialogAlerProvider: FunctionComponent<DialogAlertProviderProps> = (
  props
) => {
  const [alert, setAlert] = useState<boolean>(false);
  const [status, setStatus] = useState<string>('');
  const [text, setText] = useState<string>('');
  const error = (text?: { header: string; sub: string }) => {
    let secondsToGo = 1000;

    const modal = Modal.error({
      centered: true,
      className: 'modal-alert',
      icon: <Iconsvg.IconError></Iconsvg.IconError>,
      content: (
        <div className="modal-alert-text">
          <div className="modal-alert-text-header-error">{text?.header}</div>
          <div className="modal-alert-text-sub-error">{text?.sub}</div>
        </div>
      ),
      closable: false,

      footer: (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            className="button-login-submit"
            onClick={() => modal.destroy()}
          >
            กลับ
          </Button>
        </div>
      ),
    });

    const timer = setInterval(() => {
      secondsToGo -= 1;
      modal.update({
        content: (
          <div className="modal-alert-text">
            <div className="modal-alert-text-header-error">{text?.header}</div>
            <div className="modal-alert-text-sub-error">{text?.sub}</div>
            {/* <div>{` ${secondsToGo} second.`}</div> */}
          </div>
        ),
      });
      // modal.update({
      //   content: text
      //     ? `${text} ${secondsToGo} second.`
      //     : `some messages...some messages... ${secondsToGo} second.`,
      // });
    }, 1000);

    setTimeout(() => {
      clearInterval(timer);
      modal.destroy();
    }, secondsToGo * 1000);
  };
  const success = (text?: { header: string; sub: string }) => {
    const modal = Modal.success({
      centered: true,
      className: 'modal-alert',
      icon: <Iconsvg.IconSuccess />,
      content: (
        <div className="modal-alert-text">
          <div className="modal-alert-text-header-success">{text?.header}</div>
          <div className="modal-alert-text-sub-success">{text?.sub}</div>
        </div>
      ),
      closable: false,
      footer: (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            className="button-login-submit"
            onClick={() => modal.destroy()}
          >
            ตกลง
          </Button>
        </div>
      ),
    });
  };
  return (
    <DialogAlerContext.Provider
      value={{
        alert,
        setAlert,
        status,
        setStatus,
        text,
        setText,
        success,
        error,
      }}
    >
      {props.children}
    </DialogAlerContext.Provider>
  );
};

export { DialogAlerProvider, DialogAlerContext };
